export default __webpack_public_path__ + "static/media/icon-barrel.8e6fe05c.svg";